import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController } from 'ionic-angular';
import { AccountProvider } from '../../providers/account/account';
import { AwsProvider } from '../../providers/aws/aws';

@IonicPage()
@Component({
  selector: 'page-add-user',
  templateUrl: 'add-user.html',
})
export class AddUserPage {

	fields: Array<any>;
  formData: object;
  showSpinner: boolean;
  showPassword: boolean;
  errorMessages: Array<string> = [];
  showSuccess: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public accountPro: AccountProvider, public aws: AwsProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
  	this.fields = [
  		['firstName', 'text', 'First name can not be empty.'],
  		['lastName', 'text', 'Last name can not be empty.'],
  		['cellPhone', 'number', 'Invalid phone number (ex. (555) 555-5555).'],
  		['email', 'email', 'Invalid email (ex. abc@123.com).'], 
  		['password', 'password', 'Password must conatin at least 8 characters, 1 number, and 1 lowercase letter.']
  	];
    this.resetForm();
    this.showSpinner = false;
  }

  /**
   * Clear out all form fields and the form error messages
   */
  resetForm() {
  	this.formData = {};
    this.showPassword = false;
    this.errorMessages = [];
    this.showSuccess = false;
    for (var i in this.fields) {
      this.formData[this.fields[i][0]] = '';
    }
  }

  /**
   * Show password on page
   */
  showPasswordOnPage() {
    this.showPassword = true;
  }

  /**
   * Hide password from page
   */
  hidePasswordOnPage() {
    this.showPassword = false;
  }

  /** 
   * Run whenever the number field is changed, this autoformats US
   * phone numbers
   */
  numberChanged(numberField: string) {
    try {
      const number: string = this.formData[numberField].match(/\d+/g).join('');
      if (number.length > 0 && number.length < 3) {
        this.formData[numberField] = '(' + number;
      } else if (number.length > 2 && number.length < 5) {
        this.formData[numberField] = '(' + number.slice(0, 3) + ') ' + number.slice(3);
      } else if (number.length) {
        this.formData[numberField] = '(' + number.slice(0, 3) + ') ' + number.slice(3, 6) + '-' + number.slice(6);
      }
    } catch (error) { }
  }

	/**
   * Check each field for validity, collect error messages for all bad fields, 
   * returns true if entire form is valid, false otherwise.
   */
  isFormValid() {
    var valid: boolean = true;
    for (var i = 0; i < this.fields.length; i++) {
      var fieldData: Array<string> = this.fields[i];
      var result: boolean = this.isFieldValid(fieldData);
      if (!result) { // invalid field
        valid = false;
      }
    }
    return valid;
  }

  /**
   * Check if a field is valid, returns true if it is and false + adds error 
   * message to array if it is not
   * @param {String} field  field name to check validity of
   */
  isFieldValid(field: Array<string>) {

    if (field[1] == 'text') {
      if (this.validateTextInput(field[0])) {
        return true;
      } else {
      	this.errorMessages.push(field[2]);
        return false;
      }
    }

    else if (field[1] == 'number') {
      if (this.validatePhoneNumber(field[0])) {
        return true;
      } else {
      	this.errorMessages.push(field[2]);
        return false;
      }
    }

    else if (field[1] == 'email') {
      if (this.validateEmail(field[0])) {
        return true;
    	}else{
    		this.errorMessages.push(field[2]);
    		return false;
    	}
    }

    else if (field[1] == 'password') {
      if (this.validatePassword(field[0])) {
        return true;
    	}else{
    		this.errorMessages.push(field[2]);
    		return false;
    	}
    }

  }

  validateTextInput(field: string) {
    return this.formData[field].trim().length > 0;
  }

  validatePhoneNumber(field: string) {
    try {
      const number: string = this.formData[field].match(/\d+/g).join('');
      return number.length == 10;
    } catch (error) {
      return false;
    }
  }

  validateEmail(field: string) {
    var amp = this.formData[field].indexOf('@');
    var domain = this.formData[field].lastIndexOf('.');
    var emailLength = this.formData[field].length;
    if ((amp != -1) && (domain > amp) && (domain + 1 < emailLength)) {
    	return true;
    } else {
    	return false;
    }
  }

  validatePassword(field: string) {
    var hasNumbers = /\d/.test(this.formData[field]);
    var hasLetters = /[a-z]/i.test(this.formData[field]);
    var passwordLength = this.formData[field].length;
    if (hasNumbers && hasLetters && (passwordLength > 7)) {
    	return true;
    } else {
    	return false;
    }
  }
     

  submit() {
  	this.errorMessages = [];
    if (this.isFormValid()) {
      this.showSpinner = true;
      this.errorMessages = [];
      this.createAccount();
    } else {
    	this.showSuccess = false;
    }
  }

  createAccount() {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    var data: object = {
      'firstName': this.formData['firstName'],
      'lastName': this.formData['lastName'],
      'cellPhone': '+1' + this.formData['cellPhone'].match(/\d+/g).join(''),
      'email': this.formData['email'],
      'password': this.formData['password']
    };
    return this.accountPro.createAccount(data)
      .then((result) => {
        loading.dismiss();
        this.showSpinner = false;
        if (result['success'] === true) {
          this.resetForm();
          //this.showSuccess = true;
          let msg = 'The user has been added.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        } else {
        	this.errorMessages.push(result['message']);
        	//this.showSuccess = false;
          let msg = 'Error adding user record. Please try again.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-user/add-user.ts